import React, {useState, useEffect} from 'react';
import Footer from './Footer.component';

import {firestore} from '../../firebase/config';

const Gallery = () => {
  const [galleryPics, setGalleryPics] = useState([]);

  useEffect(() => {
    firestore.collection('EsthraImageURL').onSnapshot((snapshot) => {
      let documents = [];
      snapshot.forEach((doc) => {
        documents.push({...doc.data(), id: doc.id});
      });
      setGalleryPics(documents);
    });
  }, [setGalleryPics]);
  
  return (
    <React.Fragment>
      <div id='main' style={{paddingTop: '1rem'}}>
        <h1 style={{textAlign: 'center', paddingTop: '1rem'}}>Gallery</h1>
        <section id='one' className='tiles'>
          {galleryPics &&
            galleryPics.map((pic) => {
              return (
                <article key={pic.id} value={[pic.id]}>
                  <img src={pic.url} alt='Display part' title='Display title' />
                </article>
              );
            })}
        </section>
      </div>{' '}
      <hr />
      <Footer />
    </React.Fragment>
  );
};

export default Gallery;
